var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeviceIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8H8V6h1.5a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-4a.5.5 0 00-.5.5v4a.5.5 0 00.5.5H7v2H.5a.5.5 0 000 1H3v2H1.5a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h4a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5H4V9h7v2H9.5a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h4a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5H12V9h2.5a.5.5 0 000-1zM6 2h3v3H6V2zM5 15H2v-3h3v3zm8 0h-3v-3h3v3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceIcon);
export default __webpack_public_path__ + "static/media/device-icon.8021a708023f50878697b4beb28a05f7.svg";
export { ForwardRef as ReactComponent };